module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-ties.713f5ec6.png";